require('./RACoherenceModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { FormattedText } = require('core/i18n').i18n;

class RACoherenceModal extends React.Component {
    handleContinue() {
        const { closeModal, onHandleContinueFromWarningModal } = this.props;
        closeModal();
        onHandleContinueFromWarningModal();
    }

    buildNonBlokingFooter() {
        const { closeModal } = this.props;
        return (
            <div className="ra-coherence-modal__footer">
                <div className="ra-coherence-modal__button">
                    <OKButton onClick={() => this.handleContinue()}>
                        <FormattedText value="raCoherenceModal-continueButton" />
                    </OKButton>
                </div>
                <div className="ra-coherence-modal__button">
                    <OKButton onClick={closeModal}>
                        <FormattedText value="raCoherenceModal-checkButton" />
                    </OKButton>
                </div>
            </div>
        );
    }

    render() {
        const { closeModal, message, isNonBlocking } = this.props;
        const headerContent = <div className="ra-coherence-modal__icon" />;
        const contentFooter = isNonBlocking
            ? this.buildNonBlokingFooter()
            : null;
        const primaryButtonText = isNonBlocking
            ? null
            : 'raCoherenceModal-checkButton';
        const footerType = isNonBlocking ? null : 'action';

        return (
            <OKModal
                description={message}
                descriptionAlignment="center"
                footerType={footerType}
                headerContent={headerContent}
                headerType="custom"
                isOpen={true}
                onCloseCallback={closeModal}
                onPrimaryButtonClick={closeModal}
                primaryButtonText={primaryButtonText}
                shouldCloseOnOverlayClick={false}
                title="raCoherenceModal-title"
                titleAlignment="center"
                contentFooter={contentFooter}
            />
        );
    }
}

RACoherenceModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    onHandleContinueFromWarningModal: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    isNonBlocking: PropTypes.bool,
};

module.exports = RACoherenceModal;
